import _ from 'lodash'

export default class User {
  id = null
  firstname = null
  lastname = null
  email = null
  phone = null
  role = null
  companyCode = null
  company = null
  title = null
  notes = null
  state = {
    label: null
  }

  constructor (data) {
    _.forEach(data, (value, field) => {
      if (this.hasOwnProperty(field) && !(field === 'state' && value === null)) {
        this[field] = value
      }
    })
  }
}
